import React from 'react'
import '../styles/lawyer.css'

const LawyerCard = ({ id, image, name, area }) => {
    return (
        <div className="card-container text-center mb-4">
            <div className="lawyer-card mt-4">
                <img src={image} alt={name} className="lawyer-img" />
                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                    <h5 className="card-tittle">{name}</h5>
                    <p className="card-text">{area}</p>
                </div>
            </div>
        </div>
    )
}

export default LawyerCard
